import React, { useRef } from 'react'
import {
  useAddresses,
  AddressFormContextProvider,
  useUIFunctions,
  useConfigState,
  useGlobalLabels,
  readFromLocalStorage,
  writeToLocalStorage,
} from '@sentecacommerce-theme/lib'
import { AddressBookPreview } from '../AddressBookPreview'
import styled from 'styled-components'
import { AddressForm } from '../AddressForm'
import { Spinner } from '../../Spinner'
import { Button } from '../../Button'

import { AddressFormModalProps } from '../../Modals'

import { getHeight, setHeight } from '../../../Profile/utils/heightPredictor'

export const AddressBookList = ({
  withEdit = true,
}: {
  withEdit?: boolean
}) => {
  const { data } = useAddresses()
  const hasAddresses = Boolean(data?.length)
  const { globalValidations, address, save } = useGlobalLabels()
  const { enqueueView } = useUIFunctions()
  const { views } = useConfigState()

  const containerRef = useRef<HTMLDivElement | null>(null)

  if (data) setHeight({ ref: containerRef, page: 'address-book' })

  if (!data) {
    const height = getHeight('address-book')

    // 40.1rem default height for loader if there aren't any addresses added

    return (
      <LoaderContainer height={height ? height + 'px' : '40.1rem'}>
        <Spinner />
      </LoaderContainer>
    )
  }

  if (data && !hasAddresses) {
    return (
      <AddressFormContextProvider
        onSuccess={() => {}}
        errorLabels={globalValidations || {}}
      >
        <>
          <AddressForm />
          <div className="d-flex align-items-center justify-content-end">
            <Button variant="green" type="submit" borderRadius="small">
              {save}
            </Button>
          </div>
        </>
      </AddressFormContextProvider>
    )
  }

  return (
    <Container ref={containerRef}>
      {!hasAddresses && <div>{address?.noSavedAddresses}</div>}
      {hasAddresses &&
        data?.map((addr) => (
          <AddressBookContainer key={`Address__${addr._id}`}>
            <AddressBookPreview data={addr} withEdit={withEdit} />
          </AddressBookContainer>
        ))}
      {hasAddresses && (
        <Button
          variant="green"
          small
          bordered
          borderRadius="small"
          onClick={() =>
            enqueueView<AddressFormModalProps>(views.addressForm, {
              errorLabels: globalValidations || {},
            })
          }
        >
          {address?.addNewAddress}
        </Button>
      )}
    </Container>
  )
}

const Container = styled.div``

const AddressBookContainer = styled.div.attrs({
  className: 'pb-4',
})``

const LoaderContainer = styled.div<{ height: string }>`
  position: relative;
  height: ${(props) => props.height};
`
